import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class SearchService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getSuggestDataListResults(searchType, queryParams, defaultOnly) {
        const urlParams = { searchType };
        const getParams = { ...queryParams };
        if (defaultOnly) {
            getParams.defaultOnly = defaultOnly;
        }
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SUGGEST, urlParams);
        return this.ajaxService.getDataObserveBody(requestUrl, getParams);
    }
    getSearchAllResults(searchType, queryInput, pageNum, perPage = 50) {
        const urlParams = { searchType, queryInput, pageNum, perPage };
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SEARCH_ALL_DATA);
        return this.ajaxService.getDataObserveBody(requestUrl, urlParams);
    }
}
SearchService.ɵfac = function SearchService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SearchService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac, providedIn: 'root' });
